<template>
  <div>
    <v-dialog
      v-model="dialog"
      fullscreen
      eager
      persistent
      scrollable
      max-width="900px"
    >
      <v-card>
        <v-card-title dark class="dialog-header pt-5 pb-5 pl-6">
          <span>OPCR Target's Accomplishments</span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeD()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text style="max-height: 700px" class="my-4">
          <v-card>
            <v-row>
              <v-col cols="12" v-if="isSubmitted">
                <v-stepper alt-labels class="elevation-0">
                  <v-stepper-header>
                    <v-stepper-step
                      step="1"
                      class="pa-5"
                      :complete="assessed_by_status == 2 ? true : false"
                      :rules="[() => assessed_by_status != 3]"
                      color="#6DB249"
                    >
                      {{ assessed_by }}
                      <small>Assessed By<br /> </small>
                    </v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step
                      step="2"
                      class="pa-5"
                      :complete="final_rating_by_status == 2 ? true : false"
                      :rules="[() => final_rating_by_status != 3]"
                      color="#6DB249"
                    >
                      {{ final_rating_by }}
                      <small>Planning <br /> </small>
                    </v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step
                      step="3"
                      class="pa-5"
                      :complete="final_rating_by_status == 2 ? true : false"
                      :rules="[() => final_rating_by_status != 3]"
                      color="#6DB249"
                    >
                      {{ final_rating_by }}
                      <small>CPMT Member <br /> </small>
                    </v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step
                      step="4"
                      class="pa-5"
                      :complete="final_rating_by_status == 2 ? true : false"
                      :rules="[() => final_rating_by_status != 3]"
                      color="#6DB249"
                    >
                      {{ final_rating_by }}
                      <small>CPMT Head <br /> </small>
                    </v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step
                      step="5"
                      class="pa-5"
                      :complete="final_rating_by_status == 2 ? true : false"
                      :rules="[() => final_rating_by_status != 3]"
                      color="#6DB249"
                    >
                      {{ final_rating_by }}
                      <small>President <br /> </small>
                    </v-stepper-step>
                  </v-stepper-header>
                </v-stepper>
              </v-col>
              <v-col cols="8" class="flex-items mt-2">
                <v-tabs v-model="activeTab" color="#519043" align-tabs="left">
                  <v-tab
                    v-for="tab in tabList"
                    :key="tab.id"
                    @click="changeTab(tab)"
                    >{{ tab.name }}</v-tab
                  >
                </v-tabs>
              </v-col>
              <v-spacer></v-spacer>

              <v-col cols="12" class="pt-2 px-4">
                <v-data-table
                  :headers="
                    tab == 1
                      ? cf_headers
                      : tab == 2
                      ? sp_headers
                      : support_headers
                  "
                  :items="dataItem"
                  :items-per-page="10"
                >
                  <!-- <template
                    v-slot:item.data-table-expand="{ item, expand, isExpanded }"
                  >
                    <td
                      v-if="item.accomplishments.length > 0"
                      class="text-start"
                    >
                      <v-btn
                        icon
                        @click="expand(!isExpanded)"
                        class="v-data-table__expand-icon"
                        :class="{
                          'v-data-table__expand-icon--active': isExpanded,
                        }"
                      >
                        <v-icon>mdi-chevron-down</v-icon>
                      </v-btn>
                    </td>
                  </template> -->
                  <template v-slot:expanded-item="{ headers, item: parent }">
                    <td :colspan="headers.length" class="pa-4">
                      <div class="text-subtitle-1 py-1">Accomplishment</div>

                      <div>
                        <v-data-table
                          :headers="accomplishments_headers"
                          :items="parent.accomplishments"
                          hide-default-footer
                        >
                          <template v-slot:[`item.date_added`]="{ item }">
                            {{ formatDate(item.createdAt) }}
                          </template>
                          <template v-slot:[`item.action`]="{ item }">
                            <v-btn
                              block
                              x-small
                              @click="update_accomplishment(item, parent)"
                              outlined
                              class="my-1"
                              color="warning"
                              >Update</v-btn
                            >
                            <v-btn
                              block
                              x-small
                              class="my-1"
                              @click="deleteItem(item)"
                              outlined
                              color="red"
                              >delete</v-btn
                            >
                          </template>
                        </v-data-table>
                      </div>
                    </td>
                  </template>
                  <template v-slot:[`item.eqt`]="{ item }">
                    <div class="text-center">
                      <div class="d-flex align-center justify-center">
                        <div class="text-caption">E -</div>
                        <div class="align-self-center">
                          <v-icon v-if="item.eff_is_rated" color="#519043"
                            >mdi-check</v-icon
                          >
                          <v-chip v-if="!item.eff_is_rated" x-small>NR</v-chip>
                        </div>
                      </div>
                      <div class="d-flex align-center justify-center">
                        <div class="text-caption">Q -</div>
                        <div class="align-self-center">
                          <v-icon v-if="item.qly_is_rated" color="#519043"
                            >mdi-check</v-icon
                          >
                          <v-chip v-if="!item.qly_is_rated" x-small>NR</v-chip>
                        </div>
                      </div>
                      <div class="d-flex align-center justify-center">
                        <div class="text-caption">T -</div>

                        <div class="align-self-center">
                          <v-icon
                            v-if="item.timeliness_is_rated"
                            color="#519043"
                            >mdi-check</v-icon
                          >
                          <v-chip v-if="!item.timeliness_is_rated" x-small
                            >NR</v-chip
                          >
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-slot:[`item.alloted_budget`]="{ item }">
                    {{
                      item.alloted_budget
                        ? formatPrice(item.alloted_budget)
                        : ""
                    }}
                  </template>
                  <template v-slot:[`item.tagged_target`]="{ item }">
                    {{
                      tab == 2
                        ? myTaggingType.type == "vp"
                          ? item.target
                          : item.tagged_target
                        : null
                    }}
                  </template>
                  <template v-slot:[`item.actual_accomplishment`]="{ item }">
                    {{
                      tab == 2
                        ? myTaggingType.type == "vp"
                          ? item.actual_accomplishment
                          : item.OpcrPapTargetDistributedTagging_actual_accomplishment
                        : item.actual_accomplishment
                    }}
                  </template>

                  <template v-slot:[`item.action`]="{ item }">
                    <v-btn
                      v-if="
                        tab == 1
                          ? myTaggingType.type != 'unit_head' &&
                            item.OpcrPapTargetDistributedTaggingCount != 0
                          : tab == 2
                          ? myTaggingType.type == 'dean'
                            ? false
                            : item.isDistributed == 1
                          : false
                      "
                      :block="tab != 3"
                      x-small
                      @click="view_opcr_linked(item)"
                      outlined
                      color="primary"
                      class="my-1"
                      >tagged opcr</v-btn
                    >
                    <v-btn
                      v-if="shouldSeeLinked(item)"
                      :block="tab != 3"
                      x-small
                      @click="view_accomplishment(item)"
                      outlined
                      color="#519043"
                      class="my-1"
                      >linked ipcr</v-btn
                    >
                    <v-btn
                      v-if="item.accomplishments.length > 0"
                      block
                      @click="
                        ViewFileAttached(item.accomplishments[0].attachment)
                      "
                      x-small
                      outlined
                      color="warning"
                      class="my-1"
                      >View Attachment</v-btn
                    >

                    <!-- <v-btn
                      v-if="shouldAddAccomplishment(item)"
                      :block="tab != 3"
                      x-small
                      @click="add_accomplishment(item)"
                      outlined
                      color="#519043"
                      >Add Accomplishment</v-btn
                    >

                    <v-btn
                      v-if="shouldViewCascadedAccomplishment(item)"
                      :block="tab != 3"
                      x-small
                      @click="view_accomplishment(item)"
                      outlined
                      color="blue"
                      >Tagged Accomplishment</v-btn
                    > -->
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
            <v-row v-if="isSubmitted && assessed_by_status == 2">
              <v-col cols="12">
                <v-divider></v-divider>
                <div class="pa-3">
                  <div class="text-h6">
                    Comments and Recommendations for Development Purposes:
                  </div>
                  <div class="text-justify text-subtitle-1">
                    {{ targetRating.comments }}
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-5">
          <v-fab-transition v-if="isSubmitted">
            <v-menu top>
              <template v-slot:activator="{ on }">
                <v-btn color="#519043" left outlined v-on="on"> Remarks </v-btn>
              </template>

              <v-card class="mx-auto" width="600" max-width="600" elevation-4>
                <v-card-title class="dialog-header white--text">
                  <span class="text-h6">Remarks</span>
                </v-card-title>
                <v-card-text
                  class="py-0"
                  style="
                    background-color: white;
                    height: 300px;
                    overflow-y: auto;
                  "
                >
                  <v-timeline dense v-if="remarksData.length > 0">
                    <v-timeline-item
                      v-for="item in remarksData"
                      :key="item.id"
                      small
                      color="#519043"
                      icon="mdi-comment-processing-outline"
                      fill-dot
                    >
                      <v-alert :value="true">
                        <div class="text-h6">
                          {{
                            $store.getters.getUserData.id ==
                            item.remarks_maker_userID
                              ? "You"
                              : item.remarks_by
                          }}
                        </div>
                        <div class="text-body-1">
                          {{ item.message }}
                        </div>
                        <div class="text-caption">
                          <i>{{ formatDate(item.created_at) }}</i>
                        </div>
                      </v-alert>
                    </v-timeline-item>
                  </v-timeline>
                  <v-timeline dense v-if="remarksData.length == 0">
                    <v-timeline-item
                      small
                      color="#519043"
                      icon="mdi-comment-processing-outline"
                      fill-dot
                    >
                      <v-alert :value="true">
                        <div class="text-body-1">No remarks found.</div>
                      </v-alert>
                    </v-timeline-item>
                  </v-timeline>
                </v-card-text>
              </v-card>
            </v-menu>
          </v-fab-transition>
          <v-spacer></v-spacer>

          <v-btn color="red" outlined @click="closeD()">
            <v-icon>mdi-close-circle-outline</v-icon>
            Close
          </v-btn>

          <v-btn
            v-if="shouldSubmit()"
            color="#519043"
            class="white--text"
            @click="submitTarget()"
          >
            <v-icon>mdi-check-circle</v-icon>
            Submit
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- delete dialog -->
    <v-dialog v-model="confirmDialog" persistent max-width="390">
      <v-card color="white">
        <div class="pa-4 #3a3b3a--text">
          <div class="text-h6 mb-1">WARNING!</div>
          <div class="text-body-1 mb-1">
            <p style="text-align: justify">
              <v-icon class="mt-n2" color="white">mdi-alert</v-icon> &nbsp; Are
              you sure you want to delete this information?<br /><br />
              Please note that
              <b>this action is irreversible.</b>
            </p>
          </div>
        </div>

        <!-- <v-card-title class="text-h5">
            Are you sure you want to proceed?
          </v-card-title> -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" outlined @click="cancelDelete()"> Close </v-btn>
          <v-btn
            :disabled="isButtonLoading"
            :loading="isButtonLoading"
            color="green"
            class="white--text"
            @click="confirmDelete()"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="confirmSubmitDialog" persistent max-width="390">
      <v-card color="white">
        <div class="pa-4 #3a3b3a--text">
          <div class="text-h6 mb-1">WARNING!</div>
          <div class="text-body-1 mb-1">
            <p style="text-align: justify">
              <v-icon class="mt-n2" color="white">mdi-alert</v-icon> &nbsp; Are
              you sure you want to submit this
              <b>Targets for Approval</b>?<br />
              <!-- Please note that
                <b>this action is irreversible.</b> -->
            </p>
          </div>
        </div>

        <!-- <v-card-title class="text-h5">
            Are you sure you want to proceed?
          </v-card-title> -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :disabled="confirmBtnLoading"
            color="red"
            outlined
            @click="cancelConfirm()"
          >
            Close
          </v-btn>
          <v-btn
            :disabled="confirmBtnLoading"
            :loading="confirmBtnLoading"
            color="green"
            class="white--text"
            @click="confirmSubmit()"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- <AddAccomplishmentDialog
      :data="opcrData"
      :action="action"
      :opcrID="id"
      :tab="tab"
    /> -->

    <ViewCascadedAccomplishmentDialog
      :data="viewCascade"
      :tab="tab"
      :myTaggingType="myTaggingType"
    />

    <ViewOPCRLinkedTargetsDialog
      :data="viewLinkedOPCR"
      :tab="tab"
      :myTaggingType="myTaggingType"
    />

    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>

<script>
export default {
  components: {
    // AddAccomplishmentDialog: () =>
    //   import("../OPCR/AddAccomplishmentDialog.vue"),
    ViewCascadedAccomplishmentDialog: () =>
      import("./ViewCascadedAccomplishmentDialog.vue"),
    ViewOPCRLinkedTargetsDialog: () =>
      import("./ViewOPCRLinkedTargetsDialog.vue"),
  },
  props: {
    data: null,
  },
  data() {
    return {
      remarksData: [],
      confirmBtnLoading: false,
      confirmSubmitDialog: false,
      confirmDialog: false,
      itemToDelete: null,
      assesed_by_status: null,
      options: {},
      action: null,
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
      mporData: [],
      dialog: false,
      activeTab: { id: 1, name: "Core Functions" },
      tab: 1,
      tabList: [
        { id: 1, name: "Core Functions" },
        { id: 2, name: "Strategic Priority" },
        // { id: 3, name: "Support Functions" },
      ],
      opcrData: null,
      opcrSupData: null,
      isSubmitted: null,
      targetRating: null,
      isSubmitLoading: false,
      assessed_by: null,
      assessed_by_status: null,
      final_rating_by: null,
      final_rating_by_status: null,
      id: null,
      ipcrSupport: null,
      dataItem: [],
      expanded: [],
      isButtonLoading: false,
      cf_headers: [
        {
          text: "MFO",
          value: "mfo",
          width: 300,
          align: "start",
          valign: "start",
          sortable: false,
        },
        {
          text: "Success Indicator",
          value: "success_indicator",
          align: "start",
          width: 300,
          valign: "center",
          sortable: false,
        },
        {
          text: "Tagged Target/s",
          value: "efficiency",
          align: "center",
          width: 100,
          valign: "center",
          sortable: false,
        },
        {
          text: "Alloted Budget",
          value: "alloted_budget",
          width: 100,
          align: "center",
          valign: "center",
          sortable: false,
        },
        {
          text: "Actual Accomplishment",
          value: "actual_accomplishment",
          width: 300,
          align: "start",
          valign: "center",
          sortable: false,
        },

        {
          text: "Action",
          value: "action",
          width: 150,
          align: "center",
        },
      ],
      sp_headers: [
        {
          text: "Code",
          value: "code",
          width: 100,
          align: "start",
          valign: "start",
          sortable: false,
        },
        {
          text: "MFO",
          value: "mfo",
          width: 300,
          align: "start",
          valign: "start",
          sortable: false,
        },
        {
          text: "Success Indicator",
          value: "success_indicator",
          align: "start",
          width: 300,
          valign: "center",
          sortable: false,
        },
        {
          text: "Tagged Target/s",
          value: "tagged_target",
          align: "center",
          width: 300,
          valign: "center",
          sortable: false,
        },
        {
          text: "Alloted Budget",
          value: "alloted_budget",
          align: "center",
          valign: "center",
          sortable: false,
        },

        {
          text: "Actual Accomplishment",
          value: "actual_accomplishment",
          align: "start",
          valign: "center",
          sortable: false,
        },
        {
          text: "Action",
          value: "action",
          width: 150,
          align: "end",
        },
      ],

      accomplishments_headers: [
        // {
        //   text: "Description",
        //   value: "description",
        //   align: "start",
        //   valign: "start",
        //   sortable: false,
        // },
        {
          text: "Accomplishment Achieved",
          value: "accomplishment",
          align: "start",
          valign: "center",
          sortable: false,
        },
        {
          text: "Date Added",
          value: "date_added",
          align: "start",
          valign: "center",
          sortable: false,
        },
        {
          text: "Action",
          value: "action",
          width: 150,
          align: "end",
        },
      ],
      support_headers: [
        {
          text: "Success Indicator",
          value: "success_indicator",
          align: "start",
          sortable: false,
        },
        {
          text: "Actual Accomplishment",
          value: "actual_accom",
          align: "center",

          valign: "center",
          sortable: false,
        },

        {
          text: "To be Rated",
          value: "eqt",
          align: "center",
          valign: "center",
          sortable: false,
        },
        {
          text: "Action",
          value: "action",
          align: "end",
        },
      ],
      myTaggingType: null,
      viewCascade: null,
      viewLinkedOPCR: null,
    };
  },

  watch: {
    data: {
      handler(data) {
        this.dialog = true;
        console.log("DSASD", data);
        this.getMyTaggingType();
        this.isSubmitted = data.accomplishment_submission.is_submitted;
        // this.assessed_by = this.toTitleCase(data.assessed_by_name);
        this.assessed_by_status = data.assesed_by_status;
        this.id = data.id;
        this.activeTab = { id: 1, name: "Core Functions" };
        this.tab = 1;
        this.initialize();
      },
      deep: true,
    },
    options: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
  },
  mounted() {
    // this.eventHub.$on("closeAddAccomplishmentDialog", () => {
    //   this.initialize();
    // });
    this.eventHub.$on("closeViewCascadedAccomplishmentDialog", () => {
      this.initialize();
    });
    this.eventHub.$on("closeViewOPCRLinkedTargetsDialog", () => {
      this.initialize();
    });
  },

  beforeDestroy() {
    this.eventHub.$off("closeAddAccomplishmentDialog");
    this.eventHub.$off("closeViewCascadedAccomplishmentDialog");
    this.eventHub.$off("closeViewOPCRLinkedTargetsDialog");
  },

  methods: {
    initialize() {
      this.loading = true;

      this.loadRemarks(this.data.id);

      this.axiosCall(
        "/opcr-target/getMyOPCRTargetBy/" + this.data.id + "/" + this.tab,
        "GET"
      ).then((res) => {
        if (res) {
          console.log("Init", res.data);
          this.expanded = [];
          this.dataItem = res.data;
          this.loading = false;
        }
      });
    },

    shouldAddAccomplishment(item) {
      let should = true;
      if (this.myTaggingType.type == "unit_head") {
        if (this.tab == 2) {
          should = item.isDistributed && item.accomplishments.length == 0;
        } else {
          should =
            item.OpcrPapTargetDistributedTaggingCount == "0" &&
            item.opcr_pap_target_distributed_tagging_ID == null &&
            item.opcr_pap_target_distributed_tagging_ID == null;
        }
      } else if (this.myTaggingType.type == "dean") {
        if (this.tab == 2) {
          should = item.isDistributed && item.accomplishments.length == 0;
        } else {
          should =
            // item.OpcrPapTargetDistributedTaggingCount == "0" &&
            (item.opcr_pap_target_distributed_tagging_ID ||
              item.OpcrPapTargetDistributedTaggingID) &&
            item.accomplishments.length == 0;
        }
      } else if (this.myTaggingType.type == "director") {
        if (this.tab == 2) {
          should = item.isDistributed && item.accomplishments.length == 0;
        } else {
          should =
            item.OpcrPapTargetDistributedTaggingCount == "0" &&
            item.opcr_pap_target_distributed_tagging_ID == null &&
            item.opcr_pap_target_distributed_tagging_ID == null;
        }
      } else if (this.myTaggingType.type == "vp") {
        if (this.tab == 2) {
          should = !item.isDistributed && item.accomplishments.length == 0;
        } else {
          should =
            item.OpcrPapTargetDistributedTaggingCount == "0" &&
            // (item.opcr_pap_target_distributed_tagging_ID ||
            //   item.OpcrPapTargetDistributedTaggingID) &&
            item.accomplishments.length == 0;
        }
      }

      return should;
    },

    shouldViewCascadedAccomplishment(item) {
      let should = true;
      if (this.myTaggingType.type == "dean") {
        if (this.tab == 2) {
          should = false;
        } else {
          should =
            !(
              // item.OpcrPapTargetDistributedTaggingCount == "0" &&
              (
                item.opcr_pap_target_distributed_tagging_ID ||
                item.OpcrPapTargetDistributedTaggingID
              )
            ) && item.accomplishments.length == 0;
        }
      } else if (this.myTaggingType.type == "director") {
        if (this.tab == 2) {
          should = item.isDistributed;
        } else {
          should =
            item.OpcrPapTargetDistributedTaggingCount > 0 &&
            item.opcr_pap_target_distributed_tagging_ID &&
            item.OpcrPapTargetDistributedTaggingID;
        }
      } else if (this.myTaggingType.type == "vp") {
        if (this.tab == 2) {
          should = item.isDistributed;
        } else {
          should =
            item.OpcrPapTargetDistributedTaggingCount > 0 &&
            (item.opcr_pap_target_distributed_tagging_ID ||
              item.OpcrPapTargetDistributedTaggingID);
        }
      }

      return should;
    },

    shouldSeeLinked(item) {
      if (this.tab == 1) {
        if (this.myTaggingType.type == "unit_head") {
          return true;
        } else {
          if (item.OpcrPapTargetDistributedTaggingCount > 0) {
            return false;
          } else {
            return true;
          }
        }
      } else {
        if (this.myTaggingType.type == "dean") {
          return true;
        } else {
          return item.isDistributed == 0;
        }
      }
    },

    loadAccomplishment({ item }) {
      let index = this.dataItem.findIndex((e) => e.id == item.id);
      console.log("called index", index, item);

      this.axiosCall(
        "/opcr-target/getAccomplishments/" + item.id + "/" + this.tab,
        "GET"
      ).then((res) => {
        console.log("da", res.data);
        Object.assign(this.dataItem[index], {
          accomplishments: res.data,
        });

        console.log("data", this.dataItem);
      });
    },

    shouldSubmit() {
      if (this.isSubmitted == 0) {
        return true;
      } else {
        if (this.data) {
          let approval_arr = [
            this.data.accomplishment_submission.imm_approval_status,
            this.data.accomplishment_submission.planning_user_approval_status,
            this.data.accomplishment_submission.cpmt_approval_status,
            this.data.accomplishment_submission.cpmt_head_approval_status,
            this.data.accomplishment_submission.president_approval_status,
          ];
          console.log("APPROVL ARR", approval_arr);
          if (approval_arr.includes(3)) {
            return true;
          } else {
            return false;
          }
        } else {
          return true;
        }
      }
    },

    loadRemarks(id) {
      if (id) {
        this.axiosCall("/remarks/" + id + "/OPCR_TARGET", "GET").then((res) => {
          if (res.data) {
            console.log("remarks", res.data);
            this.remarksData = res.data;
          }
        });
      }
    },
    closeD() {
      this.eventHub.$emit("closeRateOPCRTargetDialog", false);
      this.confirmSubmitDialog = false;
      this.confirmBtnLoading = false;
      this.isSubmitLoading = false;
      this.dialog = false;
    },

    ViewFileAttached(filename) {
      let url =
        process.env.VUE_APP_SERVER +
        "/opcr-target/view/opcr-accomplishment/" +
        filename;

      let token = localStorage.getItem("token");
      const tab = window.open("about:blank");
      this.isLoading = true;
      fetch(url, { headers: { Authorization: `Bearer ${token}` } })
        .then((response) => response.blob())
        .then((blob) => {
          var _url = window.URL.createObjectURL(blob);

          tab.location = _url;
          tab.focus();
          this.isLoading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // add_accomplishment(item) {
    //   console.log("RATEssssss", item);
    //   this.opcrData = {
    //     targetType: this.tab,
    //     targetID:
    //       this.tab == 1
    //         ? item.id
    //         : this.myTaggingType.type == "vp"
    //         ? item.id
    //         : item.OpcrPapTargetDistributedTaggingID,
    //     saveToOpcrPapTargetDistributedTagging:
    //       this.tab == 1
    //         ? false
    //         : this.myTaggingType.type == "vp"
    //         ? false
    //         : true,
    //     opcrID: this.id,
    //     taggedTarget: item.target,
    //     QL_is_rated: this.tab == 1 ? item.QL_is_rated : true,
    //     timeliness_is_rated: this.tab == 1 ? item.timeliness_is_rated : true,
    //     Q_rating: item.Q_rating,
    //     T_rating: item.T_rating,
    //     success_indicator: item.success_indicator,
    //     efficiency:
    //       this.tab == 1
    //         ? item.efficiency
    //         : this.myTaggingType.type == "vp"
    //         ? item.target
    //         : item.tagged_target,
    //   };
    //   this.expanded = [];
    //   // console.log("RATE", this.opcrData);
    //   this.action = "Add";
    // },

    update_accomplishment(item, parent) {
      console.log("UPDATE DATA", item, parent);
      // this.opcrData = item;
      this.opcrData = {
        accomplishment: item.accomplishment,
        accomplishment_id: item.id,
        targetType: this.tab,
        targetID: parent.id,
        opcrID: this.myTaggingType.type == "vp" ? this.data.id : parent.opcrID,
        taggedTarget: parent.target,
        QL_is_rated: this.tab == 1 ? parent.QL_is_rated : true,
        timeliness_is_rated: this.tab == 1 ? parent.timeliness_is_rated : true,
        Q_rating: parent.Q_rating,
        T_rating: parent.T_rating,
        success_indicator: parent.success_indicator,
        efficiency: parent.efficiency,
        attachment: item.attachment,
        remarks: parent.remarks,
      };
      this.expanded = [];
      this.action = "Update";
    },

    view_opcr_linked(item) {
      this.viewLinkedOPCR = item;
      // this.viewCascade = {
      //   targetType: this.tab,
      //   targetID:
      //     this.tab == 1
      //       ? item.id
      //       : this.myTaggingType.type == "vp"
      //       ? item.id
      //       : item.OpcrPapTargetDistributedTaggingID,
      //   opcrID: this.id,
      //   taggedTarget: item.target,
      //   QL_is_rated: this.tab == 1 ? item.QL_is_rated : true,
      //   timeliness_is_rated: this.tab == 1 ? item.timeliness_is_rated : true,
      //   Q_rating: item.Q_rating,
      //   T_rating: item.T_rating,
      //   success_indicator: item.success_indicator,
      //   efficiency:
      //     this.tab == 1
      //       ? item.efficiency
      //       : this.myTaggingType.type == "vp"
      //       ? item.target
      //       : item.tagged_target,
      // };
      // this.expanded = [];
      // // console.log("RATE", this.opcrData);
      // this.action = "Add";
    },

    view_accomplishment(item) {
      console.log("ACCOMPLISHMENT", item);
      this.viewCascade = item;
      // this.viewCascade = {
      //   targetType: this.tab,
      //   targetID:
      //     this.tab == 1
      //       ? item.id
      //       : this.myTaggingType.type == "vp"
      //       ? item.id
      //       : item.OpcrPapTargetDistributedTaggingID,
      //   opcrID: this.id,
      //   taggedTarget: item.target,
      //   QL_is_rated: this.tab == 1 ? item.QL_is_rated : true,
      //   timeliness_is_rated: this.tab == 1 ? item.timeliness_is_rated : true,
      //   Q_rating: item.Q_rating,
      //   T_rating: item.T_rating,
      //   success_indicator: item.success_indicator,
      //   efficiency:
      //     this.tab == 1
      //       ? item.efficiency
      //       : this.myTaggingType.type == "vp"
      //       ? item.target
      //       : item.tagged_target,
      // };
      // this.expanded = [];
      // // console.log("RATE", this.opcrData);
      // this.action = "Add";
    },
    submitTarget() {
      this.confirmSubmitDialog = true;
    },

    confirmSubmit() {
      this.confirmBtnLoading = true;
      this.isSubmitLoading = true;
      this.axiosCall(
        "/opcr-target/submitAccomplishments/" +
          this.data.accomplishment_submission.id,
        "PATCH"
      ).then((res) => {
        if (res.data.status == 200) {
          this.confirmBtnLoading = false;
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "success";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message = res.data.msg;
          this.closeD();
        } else if (res.data.status == 400) {
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "error";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message = res.data.msg;
        }
      });
    },

    cancelConfirm() {
      this.confirmSubmitDialog = false;
    },

    AddFunction() {
      this.opcrData = { id: null, year: this.data.year };
      this.action = "Add";
    },

    changeTab(tab) {
      this.activeTab = tab;
      this.tab = tab.id;
      this.initialize();
    },
    deleteItem(item) {
      this.itemToDelete = item;
      this.confirmDialog = true;
    },
    cancelDelete() {
      this.itemToDelete = null;
      this.confirmDialog = false;
    },

    confirmDelete() {
      this.isButtonLoading = true;
      this.axiosCall(
        "/opcr-target/deleteAccomplishment/" + this.itemToDelete.id,
        "DELETE"
      ).then((res) => {
        if (res.data.status == 200) {
          this.confirmDialog = false;
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "success";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message = res.data.msg;
          this.isButtonLoading = false;
          this.itemToDelete = null;
          this.confirmDialog = false;

          this.initialize();
        } else {
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "error";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message = res.data.msg;
          this.isButtonLoading = false;
        }
      });
    },
    getMyTaggingType() {
      this.axiosCall("/opcr-target/getMyTaggingType", "GET").then((res) => {
        this.myTaggingType = res.data;
      });
    },
  },
};
</script>
<style scoped></style>
